<template>
  <div v-if="items && items.length">
    <TitleBlock :text="titleText" :link="searchLink" />
    <div class="row">
      <div
        v-for="(article, index) in items"
        :key="article.uuid"
        class="column column--1-2"
      >
        <!-- product access set to true as endpoint doesn't provide data for this, should it? -->
        <Article
          :title="article.title"
          :desc="index < 4 ? article.summary : null"
          :image="article.field_image"
          :date="article.publishDate"
          :tags="index < 4 ? article.tags : null"
          :link="article.url"
          :file="
            article.file && article.file.length > 0
              ? `${$config.baseURL}${article.file}`
              : null
          "
          :size="index > 3 ? 'small border' : null"
          :has-access="hasAccess"
          :filter-tags-by-vocabulary="filterTagsByVocabulary"

        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titleText: {
      type: String,
      default: null,
    },
    searchLink: {
      type: String,
      default: null,
    },
    items: {
      type: Array,
      default: null,
    },
    filterTagsByVocabulary: {
      // Expects something similar to this: { vid: "jurisdictions", tid: 20 }
      type: Object,
      default: null,
    },
    hasAccess: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
